module.exports = __webpack_public_path__ + "static/media/izlozba (19).b388e5f6.JPG";